export const tileset = "layer/types/TILESET";
export const color = "layer/types/COLOR";
export const collision = "layer/types/COLLISION";
